import { EventEmitter } from '@angular/core';

/**
 * EventEmitter that swallows emissions structurally equal to the last one.
 * Equality is JSON-based: emitted values are plain serializable objects.
 */
export class UniqueEventEmitter<T> extends EventEmitter<T> {
  private lastKey: string | null = null;

  override emit(value?: T): void {
    const key = value === undefined || value === null ? null : JSON.stringify(value);

    if (key !== this.lastKey) {
      super.emit(value);
      this.lastKey = key;
    }
  }

  reset() {
    this.lastKey = null;
  }
}
